import { AgentProfile } from "@closerplatform/spinner-openapi";
import React from "react";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { DeleteCrossIcon } from "@fidget/common/components/icons/deleteCrossIcon/DeleteCrossIcon";
import { LimitedList } from "../../../../limitedList/limitedList";
import { TooltipPopper } from "@fidget/common/components/tooltipPopper";
import styles from "./advisersAvatarList.css";

const CONTAINER_MAX_HEIGHT = 56; // inline with `advisersAvatarList.css`
const ROW_HEIGHT = 25;

interface Props {
  advisers: AgentProfile[];
  onDelete?(adviser: AgentProfile): void;
}

export const AdvisersAvatarList = ({ advisers, onDelete }: Props) => {
  return (
    <LimitedList
      maxHeight={CONTAINER_MAX_HEIGHT}
      rowHeight={ROW_HEIGHT}
      className={styles.container}
    >
      {advisers.map((adviser) => (
        <div key={adviser.id} className={styles["agent-container"]}>
          <TooltipPopper tooltip={`${adviser.firstName} ${adviser.lastName}`}>
            <div className={styles.avatar}>
              <Avatar agent={adviser} />
            </div>
          </TooltipPopper>
          {onDelete && <DeleteCrossIcon onClick={() => onDelete(adviser)} />}
        </div>
      ))}
    </LimitedList>
  );
};
